import { Button, Stack, Tooltip } from '@dtx-company/design-system/src'
import { FC } from 'react'
import { SocialLinkUrlFields } from '../../../Destination/types'
import { circleLogoUrlForProvider } from '../utils'
import Image from 'next/image'

interface SocialChipProps {
  provider: SocialLinkUrlFields
  displayText: string
  selected: boolean
  updateSelectedLinks: (linkType: SocialLinkUrlFields) => void
}

export const SocialChip: FC<SocialChipProps> = ({
  provider,
  displayText,
  selected,
  updateSelectedLinks
}) => {
  return (
    <Stack>
      <Tooltip title={displayText}>
        <Button
          variant={selected ? 'outlined' : 'text'}
          onClick={() => updateSelectedLinks(provider)}
          sx={{}}
        >
          <Image
            src={circleLogoUrlForProvider(provider)}
            width={44}
            height={44}
            alt={displayText}
          />
        </Button>
      </Tooltip>
    </Stack>
  )
}
